module.exports = __webpack_public_path__ + "static/media/Logo Analytics.e326790e.svg";